import { render, staticRenderFns } from "./ProductCardBackgroundAudio.vue?vue&type=template&id=1d8a6c62&scoped=true&"
import script from "./ProductCardBackgroundAudio.vue?vue&type=script&lang=js&"
export * from "./ProductCardBackgroundAudio.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardBackgroundAudio.vue?vue&type=style&index=0&id=1d8a6c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a6c62",
  null
  
)

export default component.exports